import { render, staticRenderFns } from "./addGrid.vue?vue&type=template&id=02bdc37c&scoped=true&"
import script from "./addGrid.vue?vue&type=script&lang=js&"
export * from "./addGrid.vue?vue&type=script&lang=js&"
import style0 from "./addGrid.vue?vue&type=style&index=0&id=02bdc37c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bdc37c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02bdc37c')) {
      api.createRecord('02bdc37c', component.options)
    } else {
      api.reload('02bdc37c', component.options)
    }
    module.hot.accept("./addGrid.vue?vue&type=template&id=02bdc37c&scoped=true&", function () {
      api.rerender('02bdc37c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/performancecenter/theater/addGrid.vue"
export default component.exports